interface EventMessageProps {
  ALERT_ID?: string;
  ALERT_NAME?: string;
  ALLOWED_TWO_STEP_VERIFICATION_METHOD?: string;
  API_CLIENT_NAME?: string;
  API_SCOPES?: string;
  APPLICATION_NAME?: string;
  APP_ID?: string;
  APP_LICENSE?: string;
  APP_TYPE?: string;
  ASP_ID?: string;
  BIRTHDATE?: string;
  CHART_FILTERS?: string;
  CHART_NAME?: string;
  CHROME_OS_SESSION_TYPE?: string;
  COMPANY_DEVICE_ID?: string;
  DESTINATION_USER_EMAIL?: string;
  DEVICE_ID?: string;
  DEVICE_SERIAL_NUMBER?: string;
  DEVICE_TYPE?: string;
  DIRECTORY_API_ID?: string;
  DOMAIN_ALIAS?: string;
  DOMAIN_NAME?: string;
  DOMAIN_VERIFICATION_METHOD?: string;
  EMAIL_LOG_SEARCH_MSG_ID?: string;
  EMAIL_MONITOR_DEST_EMAIL?: string;
  END_DATE?: string;
  END_DATE_TIME?: string;
  EXCHANGE_ROLE_ACCOUNT?: string;
  EXCHANGE_WEB_SERVICES_URL?: string;
  FIELD_NAME?: string;
  FLASHLIGHT_EDU_NON_FEATURED_SERVICES_SELECTION?: string;
  FULL_ORG_UNIT_PATH?: string;
  GROUP_EMAIL?: string;
  GROUP_PRIORITIES?: string;
  INFO_TYPE?: string;
  INVESTIGATION_DATA_SOURCE?: string;
  INVESTIGATION_OBJECT_IDENTIFIER?: string;
  INVESTIGATION_QUERY?: string;
  MANAGED_CONFIGURATION_NAME?: string;
  MOBILE_APP_PACKAGE_ID?: string;
  MOBILE_CERTIFICATE_COMMON_NAME?: string;
  MOBILE_WIRELESS_NETWORK_NAME?: string;
  NEW_VALUE?: string;
  NUMBER_OF_ADDITIONAL_EXCHANGE_ENDPOINTS?: string;
  NUMBER_OF_COMPANY_OWNED_DEVICES?: string;
  OAUTH2_APP_NAME?: string;
  OAUTH2_NUM_APPS?: string;
  OAUTH2_SERVICE_NAME?: string;
  OLD_VALUE?: string;
  ORG_UNIT_NAME?: string;
  PLAY_FOR_WORK_MDM_VENDOR_NAME?: string;
  PLAY_FOR_WORK_TOKEN_ID?: string;
  PRINTER_NAME?: string;
  PRINT_SERVER_NAME?: string;
  PRIVILEGE_NAME?: string;
  PRODUCT_NAME?: string;
  QUARANTINE_NAME?: string;
  REQUEST_ID?: string;
  RESOURCE_IDENTIFIER?: string;
  ROLE_NAME?: string;
  RULE_NAME?: string;
  SECONDARY_DOMAIN_NAME?: string;
  SERVICE_NAME?: string;
  SETTING_NAME?: string;
  SHARED_DRIVE_ID?: string;
  SITE_LOCATION?: string;
  SITE_NAME?: string;
  SKU_NAME?: string;
  START_DATE?: string;
  USER_CUSTOM_FIELD?: string;
  USER_DISPLAY_NAME?: string;
  USER_EMAIL?: string;
  USER_NICKNAME?: string;
  WEB_ADDRESS?: string;
  WEB_ORIGIN?: string;
  WHITELISTED_GROUPS?: string;
  // Additional properties found in the codebase
  DEVICE_PREVIOUS_STATE?: string;
  DEVICE_NEW_STATE?: string;
  DEVICE_COMMAND_DETAILS?: string;
  DEVICE_PREVIOUS_ORG_UNIT?: string;
  DEVICE_NEW_ORG_UNIT?: string;
  SERVICE_ACCOUNT_EMAIL?: string;
  SHARED_DRIVE_NAME?: string;
  ORG_BRANDING_PROVISIONING_STATUS?: string;
  DOCUMENT_ID?: string;
  ORG_BRANDING_EDITOR_TYPE?: string;
  ORG_BRANDING_UPLOAD_STATUS?: string;
  APP_LICENSES_ORDER_NUMBER?: string;
  CHROME_NUM_LICENSES_PURCHASED?: string;
  EMAIL_LOG_SEARCH_START_DATE?: string;
  EMAIL_LOG_SEARCH_END_DATE?: string;
  EMAIL_LOG_SEARCH_SENDER?: string;
  EMAIL_LOG_SEARCH_RECIPIENT?: string;
  GROUP_MEMBER_BULK_UPLOAD_TOTAL_NUMBER?: string;
  GROUP_MEMBER_BULK_UPLOAD_FAILED_NUMBER?: string;
  DISTRIBUTION_ENTITY_NAME?: string;
  DISTRIBUTION_ENTITY_TYPE?: string;
  CHROME_LICENSES_ENABLED?: string;
  ACTION_TYPE?: string;
  ACTION_ID?: string;
  PERMISSION_GROUP_NAME?: string;
  OLD_PERMISSION_GRANT_STATE?: string;
  NEW_PERMISSION_GRANT_STATE?: string;
  CHROME_LICENSES_ALLOWED?: string;
  TARGET_ENTITY_TYPE?: string;
  TARGET_ENTITY_NAME?: string;
  CAA_ASSIGNMENTS_OLD?: string;
  CAA_ENFORCEMENT_ENDPOINTS_OLD?: string;
  CAA_ASSIGNMENTS_NEW?: string;
  CAA_ENFORCEMENT_ENDPOINTS_NEW?: string;
  BULK_UPLOAD_SUCCESS_OAUTH_APPS_NUMBER?: string;
  BULK_UPLOAD_TOTAL_OAUTH_APPS_NUMBER?: string;
  REAUTH_APPLICATION?: string;
  REAUTH_SETTING_OLD?: string;
  REAUTH_SETTING_NEW?: string;
  BULK_UPLOAD_FAIL_USERS_NUMBER?: string;
  BULK_UPLOAD_TOTAL_USERS_NUMBER?: string;
  SECURITY_CENTER_RULE_NAME?: string;
  SECURITY_CENTER_RULE_TRIGGER_WINDOW?: string;
  SECURITY_CENTER_RULE_CONDITION?: string;
  SECURITY_CENTER_RULE_THRESHOLD?: string;
  SECURITY_CENTER_RULE_TIME_FRAME?: string;
  SECURITY_CENTER_RULE_ACTION?: string;
}

export const eventNames = [
  // APPLICATION
  {
    value: 'CHANGE_APPLICATION_SETTING',
    label: 'Application Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `For ${APPLICATION_NAME}, ${SETTING_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CREATE_APPLICATION_SETTING',
    label: 'Application Setting Creation',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, SETTING_NAME, NEW_VALUE } = props;
      return `For ${APPLICATION_NAME}, ${SETTING_NAME} created with value ${NEW_VALUE}`;
    },
  },
  {
    value: 'DELETE_APPLICATION_SETTING',
    label: 'Application Setting Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, SETTING_NAME, OLD_VALUE } = props;
      return `For ${APPLICATION_NAME}, ${SETTING_NAME} with value ${OLD_VALUE} deleted`;
    },
  },
  {
    value: 'REORDER_GROUP_BASED_POLICIES_EVENT',
    label: 'Application Setting Group Priorities Change',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, SETTING_NAME, GROUP_PRIORITIES } = props;
      return `For ${APPLICATION_NAME}, group override priorities for ${SETTING_NAME} changed to ${GROUP_PRIORITIES}.`;
    },
  },
  {
    value: 'GPLUS_PREMIUM_FEATURES',
    label: 'Google+ Premium Features',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Premium features for Google+ service for your organization changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CREATE_MANAGED_CONFIGURATION',
    label: 'Managed configuration is created',
    messageFormat: (props: EventMessageProps) => {
      const { MANAGED_CONFIGURATION_NAME, MOBILE_APP_PACKAGE_ID } = props;
      return `Managed configuration with name ${MANAGED_CONFIGURATION_NAME} is created for android application ${MOBILE_APP_PACKAGE_ID}.`;
    },
  },
  {
    value: 'DELETE_MANAGED_CONFIGURATION',
    label: 'Managed configuration is deleted',
    messageFormat: (props: EventMessageProps) => {
      const { MANAGED_CONFIGURATION_NAME, MOBILE_APP_PACKAGE_ID } = props;
      return `Managed configuration with name ${MANAGED_CONFIGURATION_NAME} is deleted for android application ${MOBILE_APP_PACKAGE_ID}.`;
    },
  },
  {
    value: 'UPDATE_MANAGED_CONFIGURATION',
    label: 'Managed configuration is updated',
    messageFormat: (props: EventMessageProps) => {
      const { MANAGED_CONFIGURATION_NAME, MOBILE_APP_PACKAGE_ID } = props;
      return `Managed configuration with name ${MANAGED_CONFIGURATION_NAME} is updated for android application ${MOBILE_APP_PACKAGE_ID}.`;
    },
  },
  {
    value: 'FLASHLIGHT_EDU_NON_FEATURED_SERVICES_SELECTED',
    label: 'Non-Featured Services Selected',
    messageFormat: (props: EventMessageProps) => {
      const { FLASHLIGHT_EDU_NON_FEATURED_SERVICES_SELECTION } = props;
      return `${FLASHLIGHT_EDU_NON_FEATURED_SERVICES_SELECTION} selection was made for Non-Featured Services.`;
    },
  },
  {
    value: 'UPDATE_SMART_FEATURES',
    label: 'Update Smart features and personalization',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Smart features and personalization setting has been updated to ${NEW_VALUE}`;
    },
  },

  // GOOGLE CALENDAR
  {
    value: 'CREATE_BUILDING',
    label: 'Building Creation',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Building ${NEW_VALUE} created`;
    },
  },
  {
    value: 'DELETE_BUILDING',
    label: 'Building Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE } = props;
      return `Building ${OLD_VALUE} deleted`;
    },
  },
  {
    value: 'UPDATE_BUILDING',
    label: 'Building Update',
    messageFormat: (props: EventMessageProps) => {
      const { RESOURCE_IDENTIFIER, FIELD_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Building ${RESOURCE_IDENTIFIER} updated field ${FIELD_NAME} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'EWS_IN_NEW_CREDENTIALS_GENERATED',
    label: 'Calendar Interop credentials generated',
    messageFormat: (props: EventMessageProps) => {
      const { EXCHANGE_ROLE_ACCOUNT } = props;
      return `New Calendar Interop Exchange authentication credentials were generated for the Google role account ${EXCHANGE_ROLE_ACCOUNT}`;
    },
  },
  {
    value: 'EWS_OUT_ENDPOINT_CONFIGURATION_RESET',
    label: 'Calendar Interop Exchange endpoint configuration cleared',
    messageFormat: () => {
      return `Calendar Interop Exchange endpoint configuration was cleared`;
    },
  },
  {
    value: 'EWS_OUT_ENDPOINT_CONFIGURATION_CHANGED',
    label: 'Calendar Interop Exchange endpoint configuration updated',
    messageFormat: (props: EventMessageProps) => {
      const {
        EXCHANGE_ROLE_ACCOUNT,
        EXCHANGE_WEB_SERVICES_URL,
        NUMBER_OF_ADDITIONAL_EXCHANGE_ENDPOINTS,
      } = props;
      return `Calendar Interop Exchange endpoint configuration was set/updated with default endpoint URL ${EXCHANGE_WEB_SERVICES_URL} and Exchange role account ${EXCHANGE_ROLE_ACCOUNT} and ${NUMBER_OF_ADDITIONAL_EXCHANGE_ENDPOINTS} additional endpoints`;
    },
  },
  {
    value: 'CREATE_CALENDAR_RESOURCE',
    label: 'Calendar Resource Creation',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Calendar resource ${NEW_VALUE} created`;
    },
  },
  {
    value: 'DELETE_CALENDAR_RESOURCE',
    label: 'Calendar Resource Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE } = props;
      return `Calendar resource ${OLD_VALUE} deleted`;
    },
  },
  {
    value: 'CREATE_CALENDAR_RESOURCE_FEATURE',
    label: 'Calendar Resource Feature Creation',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Calendar resource feature ${NEW_VALUE} created`;
    },
  },
  {
    value: 'DELETE_CALENDAR_RESOURCE_FEATURE',
    label: 'Calendar Resource Feature Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE } = props;
      return `Calendar resource feature ${OLD_VALUE} deleted`;
    },
  },
  {
    value: 'UPDATE_CALENDAR_RESOURCE_FEATURE',
    label: 'Calendar Resource Feature Update',
    messageFormat: (props: EventMessageProps) => {
      const { RESOURCE_IDENTIFIER, FIELD_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Calendar resource ${RESOURCE_IDENTIFIER} updated field ${FIELD_NAME} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'RENAME_CALENDAR_RESOURCE',
    label: 'Calendar Resource Rename',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Calendar resource ${OLD_VALUE} renamed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_CALENDAR_RESOURCE',
    label: 'Calendar Resource Update',
    messageFormat: (props: EventMessageProps) => {
      const { RESOURCE_IDENTIFIER, FIELD_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Calendar resource ${RESOURCE_IDENTIFIER} updated field ${FIELD_NAME} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CALENDAR_SETTING',
    label: 'Calendar Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for calendar service in your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CANCEL_CALENDAR_EVENTS',
    label: 'Event cancellation request created',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Event cancellation request created for ${USER_EMAIL}`;
    },
  },
  {
    value: 'RELEASE_CALENDAR_RESOURCES',
    label: 'Release resources request created',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Release resources request created for ${USER_EMAIL}`;
    },
  },

  // GOOGLE TALK
  {
    value: 'MEET_INTEROP_CREATE_GATEWAY',
    label: 'A Google Meet interoperability gateway was created.',
    messageFormat: () => {
      return `A Hangouts Meet interoperability gateway was created`;
    },
  },
  {
    value: 'MEET_INTEROP_DELETE_GATEWAY',
    label: 'A Google Meet interoperability gateway was deleted.',
    messageFormat: () => {
      return `A Hangouts Meet interoperability gateway was deleted`;
    },
  },
  {
    value: 'MEET_INTEROP_MODIFY_GATEWAY',
    label: 'A Google Meet interoperability gateway was modified.',
    messageFormat: () => {
      return `A Hangouts Meet interoperability gateway was modified`;
    },
  },
  {
    value: 'CHANGE_CHAT_SETTING',
    label: 'Hangouts Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for talk service for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },

  // CHROME OS
  {
    value: 'CHANGE_CHROME_OS_ANDROID_APPLICATION_SETTING',
    label: 'Android Application Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        APP_ID,
        SETTING_NAME,
        CHROME_OS_SESSION_TYPE,
        OLD_VALUE,
        NEW_VALUE,
      } = props;
      return `${SETTING_NAME} for Android app ${APP_ID} for session type ${CHROME_OS_SESSION_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DEVICE_STATE',
    label: 'Change device state',
    messageFormat: (props: EventMessageProps) => {
      const {
        DEVICE_TYPE,
        DEVICE_SERIAL_NUMBER,
        DEVICE_PREVIOUS_STATE,
        DEVICE_NEW_STATE,
      } = props;
      return `Changed the state of ${DEVICE_TYPE} ${DEVICE_SERIAL_NUMBER} from ${DEVICE_PREVIOUS_STATE} to ${DEVICE_NEW_STATE}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_APPLICATION_SETTING',
    label: 'Chrome Application Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        APP_ID,
        SETTING_NAME,
        CHROME_OS_SESSION_TYPE,
        OLD_VALUE,
        NEW_VALUE,
      } = props;
      return `${SETTING_NAME} for Chrome app ${APP_ID} for session type ${CHROME_OS_SESSION_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'SEND_CHROME_OS_DEVICE_COMMAND',
    label: 'Chrome OS Device Command',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, DEVICE_SERIAL_NUMBER } = props;
      return `Sent ${NEW_VALUE} command to Chrome OS device ${DEVICE_SERIAL_NUMBER}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_DEVICE_ANNOTATION',
    label: 'Chrome OS Device Property Change',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_SERIAL_NUMBER } = props;
      return `Chrome OS device ${DEVICE_SERIAL_NUMBER} had its properties updated`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_DEVICE_SETTING',
    label: 'Chrome OS Device Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for Chrome OS devices in ${ORG_UNIT_NAME} organization unit changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_DEVICE_STATE',
    label: 'Chrome OS Device State Change',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_SERIAL_NUMBER, OLD_VALUE, NEW_VALUE } = props;
      return `State of Chrome OS device ${DEVICE_SERIAL_NUMBER} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_PUBLIC_SESSION_SETTING',
    label: 'Chrome OS managed guest session setting change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for Chrome OS managed guest session in ${ORG_UNIT_NAME} organization unit changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'INSERT_CHROME_OS_PRINT_SERVER',
    label: 'Chrome OS Print Server Added',
    messageFormat: (props: EventMessageProps) => {
      const { PRINT_SERVER_NAME } = props;
      return `Print server named ${PRINT_SERVER_NAME} added.`;
    },
  },
  {
    value: 'DELETE_CHROME_OS_PRINT_SERVER',
    label: 'Chrome OS Print Server Deleted',
    messageFormat: (props: EventMessageProps) => {
      const { PRINT_SERVER_NAME } = props;
      return `Print server ${PRINT_SERVER_NAME} deleted.`;
    },
  },
  {
    value: 'UPDATE_CHROME_OS_PRINT_SERVER',
    label: 'Chrome OS Print Server Updated',
    messageFormat: (props: EventMessageProps) => {
      const { PRINT_SERVER_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Print server ${PRINT_SERVER_NAME} updated from ${OLD_VALUE} to ${NEW_VALUE}.`;
    },
  },
  {
    value: 'INSERT_CHROME_OS_PRINTER',
    label: 'Chrome OS Printer Added',
    messageFormat: (props: EventMessageProps) => {
      const { PRINTER_NAME } = props;
      return `Printer named ${PRINTER_NAME} added.`;
    },
  },
  {
    value: 'DELETE_CHROME_OS_PRINTER',
    label: 'Chrome OS Printer Deleted',
    messageFormat: (props: EventMessageProps) => {
      const { PRINTER_NAME } = props;
      return `Printer ${PRINTER_NAME} deleted.`;
    },
  },
  {
    value: 'UPDATE_CHROME_OS_PRINTER',
    label: 'Chrome OS Printer Updated',
    messageFormat: (props: EventMessageProps) => {
      const { PRINTER_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Printer ${PRINTER_NAME} updated from ${OLD_VALUE} to ${NEW_VALUE}.`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_SETTING',
    label: 'Chrome OS Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for Chrome OS devices in your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_USER_SETTING',
    label: 'Chrome OS User Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `	${SETTING_NAME} for Chrome OS users in ${ORG_UNIT_NAME} organization unit changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'DELETE_CHROME_OS_DEVICE',
    label: 'Delete Chrome OS Device',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_SERIAL_NUMBER } = props;
      return `Deleted ChromeOS device with serial number ${DEVICE_SERIAL_NUMBER}`;
    },
  },
  {
    value: 'DELETE_DUPLICATE_CHROME_OS_DEVICE',
    label: 'Delete duplicate ChromeOS device',
    messageFormat: (props: EventMessageProps) => {
      const { DIRECTORY_API_ID, DEVICE_SERIAL_NUMBER } = props;
      return `Deleted duplicate ChromeOS device with directory API ID ${DIRECTORY_API_ID} and device serial number ${DEVICE_SERIAL_NUMBER}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_ISOLATED_WEB_APPLICATION_SETTING',
    label: 'Isolated Web Application Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        APP_ID,
        SETTING_NAME,
        CHROME_OS_SESSION_TYPE,
        OLD_VALUE,
        NEW_VALUE,
      } = props;
      return `${SETTING_NAME} for Isolated Web app ${APP_ID} for session type ${CHROME_OS_SESSION_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ISSUE_DEVICE_COMMAND',
    label: 'Issue device command',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_TYPE, DEVICE_SERIAL_NUMBER, DEVICE_COMMAND_DETAILS } =
        props;
      return `Issued command to ${DEVICE_TYPE} ${DEVICE_SERIAL_NUMBER}: ${DEVICE_COMMAND_DETAILS}`;
    },
  },
  {
    value: 'MOVE_DEVICE_TO_ORG_UNIT_DETAILED',
    label: 'Move device to Organizational unit',
    messageFormat: (props: EventMessageProps) => {
      const {
        DEVICE_SERIAL_NUMBER,
        DEVICE_TYPE,
        DEVICE_PREVIOUS_ORG_UNIT,
        DEVICE_NEW_ORG_UNIT,
      } = props;
      return `Moved ${DEVICE_TYPE} ${DEVICE_SERIAL_NUMBER} from ${DEVICE_PREVIOUS_ORG_UNIT} to ${DEVICE_NEW_ORG_UNIT}`;
    },
  },
  {
    value: 'PRE_PROVISION_CHROME_OS_DEVICE',
    label: 'Pre-provision ChromeOS device',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_SERIAL_NUMBER } = props;
      return `Pre-provisioned ChromeOS device with serial number ${DEVICE_SERIAL_NUMBER}`;
    },
  },
  {
    value: 'REMOVE_CHROME_OS_APPLICATION_SETTING',
    label: 'Remove Application Setting',
    messageFormat: (props: EventMessageProps) => {
      const { APP_TYPE, APP_ID, CHROME_OS_SESSION_TYPE } = props;
      return `${APP_TYPE} app ${APP_ID} for session type ${CHROME_OS_SESSION_TYPE} removed`;
    },
  },
  {
    value: 'REMOVE_CHROME_OS_APPLICATION_SETTINGS',
    label: 'Remove Chrome Application Settings',
    messageFormat: (props: EventMessageProps) => {
      const { APP_ID } = props;
      return `Settings for Chrome app ${APP_ID} removed`;
    },
  },
  {
    value: 'REMOVE_CHROME_OS_WEB_ORIGIN_SETTINGS',
    label: 'Remove Web Origin Settings',
    messageFormat: (props: EventMessageProps) => {
      const { WEB_ORIGIN, CHROME_OS_SESSION_TYPE } = props;
      return `Settings for web origin ${WEB_ORIGIN} for session type ${CHROME_OS_SESSION_TYPE} removed`;
    },
  },
  {
    value: 'REPAIR_CENTER_DEPROVISION',
    label: 'Repair Center deprovision',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_TYPE, DEVICE_SERIAL_NUMBER, DEVICE_PREVIOUS_STATE } =
        props;
      return `Automatic deprovision by Repair Center for ${DEVICE_TYPE} ${DEVICE_SERIAL_NUMBER}. The previous device state was ${DEVICE_PREVIOUS_STATE}.`;
    },
  },
  {
    value: 'UPDATE_DEVICE',
    label: 'Update device',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_TYPE, DEVICE_SERIAL_NUMBER } = props;
      return `Updated ${DEVICE_TYPE} ${DEVICE_SERIAL_NUMBER}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_WEB_APPLICATION_SETTING',
    label: 'Web Application Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        APP_ID,
        SETTING_NAME,
        CHROME_OS_SESSION_TYPE,
        OLD_VALUE,
        NEW_VALUE,
      } = props;
      return `${SETTING_NAME} for Web app$ ${APP_ID} for session type ${CHROME_OS_SESSION_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CHROME_OS_WEB_PERMISSION_SETTING',
    label: 'Web Permission Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        WEB_ORIGIN,
        SETTING_NAME,
        CHROME_OS_SESSION_TYPE,
        OLD_VALUE,
        NEW_VALUE,
      } = props;
      return `${SETTING_NAME} for ${WEB_ORIGIN} for session type ${CHROME_OS_SESSION_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },

  // GOOGLE CONTACTS
  {
    value: 'CHANGE_CONTACTS_SETTING',
    label: 'Contacts Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for contacts service changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },

  // DELEGATED ADMIN
  {
    value: 'ASSIGN_ROLE',
    label: 'Role Assign',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME, USER_EMAIL } = props;
      return `Role ${ROLE_NAME} assigned to user ${USER_EMAIL}`;
    },
  },
  {
    value: 'CREATE_ROLE',
    label: 'Role Creation',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME } = props;
      return `New role ${ROLE_NAME} created`;
    },
  },
  {
    value: 'DELETE_ROLE',
    label: 'Role Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME } = props;
      return `Role ${ROLE_NAME} deleted`;
    },
  },
  {
    value: 'ADD_PRIVILEGE',
    label: 'Role Privilege Creation',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME, PRIVILEGE_NAME } = props;
      return `New privilege ${PRIVILEGE_NAME} created under role ${ROLE_NAME}`;
    },
  },
  {
    value: 'REMOVE_PRIVILEGE',
    label: 'Role Privilege Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME, PRIVILEGE_NAME } = props;
      return `Privilege ${PRIVILEGE_NAME} removed from role ${ROLE_NAME}`;
    },
  },
  {
    value: 'RENAME_ROLE',
    label: 'Role Rename',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME, NEW_VALUE } = props;
      return `Role renamed from ${ROLE_NAME} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_ROLE',
    label: 'Role Updated',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME } = props;
      return `Role ${ROLE_NAME} updated`;
    },
  },
  {
    value: 'UNASSIGN_ROLE',
    label: 'Unassign Role',
    messageFormat: (props: EventMessageProps) => {
      const { ROLE_NAME, USER_EMAIL } = props;
      return `Unassigned role ${ROLE_NAME} from user ${USER_EMAIL}`;
    },
  },

  // GOOGLE DRIVE
  {
    value: 'TRANSFER_DOCUMENT_OWNERSHIP',
    label: 'Document Ownership Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `Owner of documents changed from ${USER_EMAIL} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'DOCS_ORG_BRANDING_PROVISIONING',
    label: 'Drive and Docs org branding provisioning initiated',
    messageFormat: (props: EventMessageProps) => {
      const {
        SERVICE_ACCOUNT_EMAIL,
        SHARED_DRIVE_NAME,
        ORG_BRANDING_PROVISIONING_STATUS,
      } = props;
      return `Organizational branding provisioning initiated for account ${SERVICE_ACCOUNT_EMAIL} and shared drive ${SHARED_DRIVE_NAME} with status ${ORG_BRANDING_PROVISIONING_STATUS}`;
    },
  },
  {
    value: 'DOCS_ORG_BRANDING_UPLOAD',
    label: 'Drive and Docs org branding upload attempt',
    messageFormat: (props: EventMessageProps) => {
      const {
        DOCUMENT_ID,
        ORG_BRANDING_EDITOR_TYPE,
        ORG_BRANDING_UPLOAD_STATUS,
      } = props;
      return `Organizational branding document upload attempted for document ${DOCUMENT_ID} in editor ${ORG_BRANDING_EDITOR_TYPE} with status ${ORG_BRANDING_UPLOAD_STATUS}`;
    },
  },
  {
    value: 'DRIVE_DATA_RESTORE',
    label: 'Drive Data Restore',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Drive data restoration initiated for ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_DOCS_SETTING',
    label: 'Drive Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for Drive changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'MOVE_SHARED_DRIVE_TO_ORG_UNIT',
    label: 'Shared Drive Moved',
    messageFormat: (props: EventMessageProps) => {
      const { SHARED_DRIVE_ID, ORG_UNIT_NAME, NEW_VALUE } = props;
      return `Shared drive ${SHARED_DRIVE_ID} moved from ${ORG_UNIT_NAME} to ${NEW_VALUE}`;
    },
  },

  // DOMAIN
  {
    value: 'CHANGE_ACCOUNT_AUTO_RENEWAL',
    label: 'Account Automatic Renewal Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE } = props;
      return `Account automatic renewal changed to ${NEW_VALUE} on ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'ADD_APPLICATION',
    label: 'Add Application',
    messageFormat: (props: EventMessageProps) => {
      const { APP_ID, APPLICATION_NAME } = props;
      return `Application ${APPLICATION_NAME} with id ${APP_ID} has been added to the domain`;
    },
  },
  {
    value: 'ADD_APPLICATION_TO_WHITELIST',
    label: 'Add Application to Whitelist',
    messageFormat: (props: EventMessageProps) => {
      const { APP_ID, APPLICATION_NAME } = props;
      return `Application ${APPLICATION_NAME} with id ${APP_ID} has been added to whitelist for the domain`;
    },
  },
  {
    value: 'CHANGE_ADVERTISEMENT_OPTION',
    label: 'Advertisement Option Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Advertisement option for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CREATE_ALERT',
    label: 'Alert Creation',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_NAME } = props;
      return `Alert ${ALERT_NAME} has been created`;
    },
  },
  {
    value: 'CHANGE_ALERT_CRITERIA',
    label: 'Alert Criteria Change',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_NAME } = props;
      return `Alert criteria for ${ALERT_NAME} has been changed`;
    },
  },
  {
    value: 'DELETE_ALERT',
    label: 'Alert Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_NAME } = props;
      return `Alert ${ALERT_NAME} has been deleted`;
    },
  },
  {
    value: 'ALERT_RECEIVERS_CHANGED',
    label: 'Alert Receivers Changed',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_NAME, NEW_VALUE, OLD_VALUE } = props;
      return `Alert receivers for ${ALERT_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'RENAME_ALERT',
    label: 'Alert Rename',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Alert ${OLD_VALUE} has been renamed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ALERT_STATUS_CHANGED',
    label: 'Alert Status Change',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_NAME, NEW_VALUE, OLD_VALUE } = props;
      return `Alert status for ${ALERT_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ADD_DOMAIN_ALIAS',
    label: 'Alias Creation',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_ALIAS, DOMAIN_NAME } = props;
      return `An unverified ${DOMAIN_ALIAS} created as an alias of ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'REMOVE_DOMAIN_ALIAS',
    label: 'Alias Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_ALIAS, DOMAIN_NAME } = props;
      return `${DOMAIN_ALIAS} deleted as an alias of ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'SKIP_DOMAIN_ALIAS_MX',
    label: 'Alias MX Record Setup Skipped',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_ALIAS, DOMAIN_NAME } = props;
      return `Skipped MX record setup of alias ${DOMAIN_ALIAS} of domain ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'VERIFY_DOMAIN_ALIAS_MX',
    label: 'Alias MX Record Verification',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_ALIAS, DOMAIN_NAME } = props;
      return `Verified MX record of alias ${DOMAIN_ALIAS} of domain ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'VERIFY_DOMAIN_ALIAS',
    label: 'Alias Verification',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_ALIAS, DOMAIN_NAME, DOMAIN_VERIFICATION_METHOD } = props;
      return `${DOMAIN_ALIAS} verified as an alias of ${DOMAIN_NAME} using ${DOMAIN_VERIFICATION_METHOD}`;
    },
  },
  {
    value: 'TOGGLE_OAUTH_ACCESS_TO_ALL_APIS',
    label: 'All API OAuth Access Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `OAuth access for all APIs changed to ${NEW_VALUE} for your organization`;
    },
  },
  {
    value: 'TOGGLE_ALLOW_ADMIN_PASSWORD_RESET',
    label: 'Allow Admin Password Reset',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Allow admin password reset setting changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ENABLE_API_ACCESS',
    label: 'API Access Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `API access for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'AUTHORIZE_API_CLIENT_ACCESS',
    label: 'API Client Access Authorize',
    messageFormat: (props: EventMessageProps) => {
      const { API_CLIENT_NAME, API_SCOPES } = props;
      return `API client access to your organization from client ${API_CLIENT_NAME} authorized for scopes ${API_SCOPES}`;
    },
  },
  {
    value: 'REMOVE_API_CLIENT_ACCESS',
    label: 'API Client Access Remove',
    messageFormat: (props: EventMessageProps) => {
      const { API_CLIENT_NAME } = props;
      return `API client access to your organization from client ${API_CLIENT_NAME} removed`;
    },
  },
  {
    value: 'CHROME_LICENSES_REDEEMED',
    label: 'App Licenses Redeemed',
    messageFormat: (props: EventMessageProps) => {
      const {
        APP_LICENSES_ORDER_NUMBER,
        APPLICATION_NAME,
        CHROME_NUM_LICENSES_PURCHASED,
      } = props;
      return `${CHROME_NUM_LICENSES_PURCHASED} app licenses redeemed for application ${APPLICATION_NAME} using order ${APP_LICENSES_ORDER_NUMBER}`;
    },
  },
  {
    value: 'TOGGLE_AUTO_ADD_NEW_SERVICE',
    label: 'Automatic Addition Update',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Automatic addition for new services and pre-release features for your organization changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_PRIMARY_DOMAIN',
    label: 'Change Primary Domain Name',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE } = props;
      return `Primary domain name changed from ${DOMAIN_NAME} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_WHITELIST_SETTING',
    label: 'Change Whitelist Setting',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE, SETTING_NAME } = props;
      return `${SETTING_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE} for the domain`;
    },
  },
  {
    value: 'COMMUNICATION_PREFERENCES_SETTING_CHANGE',
    label: 'Communication Preferences Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, OLD_VALUE, NEW_VALUE, SETTING_NAME } = props;
      return `${SETTING_NAME} setting in Communication Preferences changed from ${OLD_VALUE} to ${NEW_VALUE} (Domain Name : ${DOMAIN_NAME})`;
    },
  },
  {
    value: 'CHANGE_CONFLICT_ACCOUNT_ACTION',
    label: 'Conflict Account Action Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Conflict account action for ${DOMAIN_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ENABLE_FEEDBACK_SOLICITATION',
    label: 'Contact for Feedback Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Can contact for feedback setting for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'TOGGLE_CONTACT_SHARING',
    label: 'Contact Sharing Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Contact sharing changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CREATE_PLAY_FOR_WORK_TOKEN',
    label: 'Create MDM vendor enrollment token',
    messageFormat: (props: EventMessageProps) => {
      const { PLAY_FOR_WORK_TOKEN_ID } = props;
      return `MDM vendor enrollment token (${PLAY_FOR_WORK_TOKEN_ID}) created`;
    },
  },
  {
    value: 'TOGGLE_USE_CUSTOM_LOGO',
    label: 'Custom Logo Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Use custom logo changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_CUSTOM_LOGO',
    label: 'Custom Logo Upload',
    messageFormat: () => {
      return `New custom logo uploaded for your organization`;
    },
  },
  {
    value: 'CHANGE_DATA_LOCALIZATION_FOR_RUSSIA',
    label: 'Data Localization For Russian Federation Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Setting for Data Localization for Russian Federation changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DATA_LOCALIZATION_SETTING',
    label: 'Data Localization Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Setting for Data Localization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DATA_PROTECTION_OFFICER_CONTACT_INFO',
    label: 'Data Protection Officer Contact Information Change',
    messageFormat: (props: EventMessageProps) => {
      const { INFO_TYPE, OLD_VALUE, NEW_VALUE } = props;
      return `Data Protection Officer ${INFO_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'DELETE_PLAY_FOR_WORK_TOKEN',
    label: 'Delete MDM vendor enrollment token',
    messageFormat: (props: EventMessageProps) => {
      const { PLAY_FOR_WORK_TOKEN_ID } = props;
      return `MDM vendor enrollment token (${PLAY_FOR_WORK_TOKEN_ID}) deleted`;
    },
  },
  {
    value: 'VIEW_DNS_LOGIN_DETAILS',
    label: 'DNS console login details viewed',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME } = props;
      return `DNS console login details for ${DOMAIN_NAME} viewed`;
    },
  },
  {
    value: 'CHANGE_DOMAIN_DEFAULT_LOCALE',
    label: 'Domain Default Locale Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Default locale for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DOMAIN_DEFAULT_TIMEZONE',
    label: 'Domain Default Timezone Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Default time zone for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DOMAIN_NAME',
    label: 'Domain Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, DOMAIN_NAME } = props;
      return `Change of domain name for ${DOMAIN_NAME} to ${NEW_VALUE} started`;
    },
  },
  {
    value: 'TOGGLE_ENABLE_PRE_RELEASE_FEATURES',
    label: 'Domain Pre-release Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Pre-release features for your organization was set to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_DOMAIN_SUPPORT_MESSAGE',
    label: 'Domain Support Message Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Support message for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ADD_TRUSTED_DOMAINS',
    label: 'Domains added to Trusted Domains',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME } = props;
      return `Domains ${DOMAIN_NAME} added to Trusted Domains list`;
    },
  },
  {
    value: 'REMOVE_TRUSTED_DOMAINS',
    label: 'Domains removed from Trusted Domains',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME } = props;
      return `Domains ${DOMAIN_NAME} removed from Trusted Domains list`;
    },
  },
  {
    value: 'CHANGE_EDU_TYPE',
    label: 'Education Organization Type Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Educational organization type changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'TOGGLE_ENABLE_OAUTH_CONSUMER_KEY',
    label: 'Enable OAuth Consumer Key',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Enabling OAuth consumer key changed to ${NEW_VALUE} for your organization`;
    },
  },
  {
    value: 'TOGGLE_SSO_ENABLED',
    label: 'Enable SSO Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE } = props;
      return `Enable SSO changed to ${NEW_VALUE} for ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'TOGGLE_SSL',
    label: 'Enforce SSL Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE } = props;
      return `SSL Enforcement changed to ${NEW_VALUE} for ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'CHANGE_EU_REPRESENTATIVE_CONTACT_INFO',
    label: 'EU Representative Contact Information Change',
    messageFormat: (props: EventMessageProps) => {
      const { INFO_TYPE, NEW_VALUE, OLD_VALUE } = props;
      return `EU Representative ${INFO_TYPE} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'GENERATE_TRANSFER_TOKEN',
    label: 'Generate Transfer Token',
    messageFormat: () => {
      return `Transfer token generated`;
    },
  },
  {
    value: 'CHANGE_LOGIN_BACKGROUND_COLOR',
    label: 'Login Background Color Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Login background color for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_LOGIN_BORDER_COLOR',
    label: 'Login Border Color Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Login border color for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_LOGIN_ACTIVITY_TRACE',
    label: 'Marketplace Login Audit Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE, OLD_VALUE } = props;
      return `Marketplace Login audit setting in ${DOMAIN_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'PLAY_FOR_WORK_ENROLL',
    label: 'MDM vendor enrollment',
    messageFormat: (props: EventMessageProps) => {
      const { PLAY_FOR_WORK_MDM_VENDOR_NAME, PLAY_FOR_WORK_TOKEN_ID } = props;
      return `Enrolled for ${PLAY_FOR_WORK_MDM_VENDOR_NAME} mobile device management services using token (${PLAY_FOR_WORK_TOKEN_ID})`;
    },
  },
  {
    value: 'PLAY_FOR_WORK_UNENROLL',
    label: 'MDM vendor unenrollment',
    messageFormat: (props: EventMessageProps) => {
      const { PLAY_FOR_WORK_MDM_VENDOR_NAME } = props;
      return `Unenrolled from ${PLAY_FOR_WORK_MDM_VENDOR_NAME} mobile device management services`;
    },
  },
  {
    value: 'MX_RECORD_VERIFICATION_CLAIM',
    label: 'MX Record Verification Claim',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, USER_EMAIL } = props;
      return `${USER_EMAIL} claimed to verify the MX record for ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'TOGGLE_NEW_APP_FEATURES',
    label: 'New App Features Update',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `New app features for your organization changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'TOGGLE_USE_NEXT_GEN_CONTROL_PANEL',
    label: 'Next Generation CPanel Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `The setting to enable the new Admin Console changed to ${NEW_VALUE} for your organization`;
    },
  },
  {
    value: 'UPLOAD_OAUTH_CERTIFICATE',
    label: 'OAuth Certificate Upload',
    messageFormat: () => {
      return `New OAuth certificate uploaded for your organization`;
    },
  },
  {
    value: 'REGENERATE_OAUTH_CONSUMER_SECRET',
    label: 'OAuth Consumer Secret Regenerate',
    messageFormat: () => {
      return `New OAuth consumer secret generated for your organization`;
    },
  },
  {
    value: 'TOGGLE_OPEN_ID_ENABLED',
    label: 'OpenId Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, NEW_VALUE } = props;
      return `TOpenId federated login for ${DOMAIN_NAME} changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_ORGANIZATION_NAME',
    label: 'Organization Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Organization name changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'TOGGLE_OUTBOUND_RELAY',
    label: 'Outbound Relay Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Outbound relay for your organization changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_PASSWORD_MAX_LENGTH',
    label: 'Password Maximum Length Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE, DOMAIN_NAME } = props;
      return `Password maximum length for ${DOMAIN_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_PASSWORD_MIN_LENGTH',
    label: 'Password Minimum Length Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE, DOMAIN_NAME } = props;
      return `Password minimum length for ${DOMAIN_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_DOMAIN_PRIMARY_ADMIN_EMAIL',
    label: 'Primary Admin Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Primary admin for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ENABLE_SERVICE_OR_FEATURE_NOTIFICATIONS',
    label: 'Receive Email Notification Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Receive email notification setting for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'REMOVE_APPLICATION',
    label: 'Remove Application',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, APP_ID } = props;
      return `Application ${APPLICATION_NAME} with id ${APP_ID} has been removed from the domain`;
    },
  },
  {
    value: 'REMOVE_APPLICATION_FROM_WHITELIST',
    label: 'Remove Application from Whitelist',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, APP_ID } = props;
      return `Application ${APPLICATION_NAME} with id ${APP_ID} has been removed from whitelist for the domain`;
    },
  },
  {
    value: 'CHANGE_RENEW_DOMAIN_REGISTRATION',
    label: 'Renew Domain Registration Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Renew domain registration setting in ${DOMAIN_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_RESELLER_ACCESS',
    label: 'Reseller Access Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Reseller access changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_RESELLER_ACCESS_FOR_SKU',
    label: 'Reseller Access Change for SKU',
    messageFormat: (props: EventMessageProps) => {
      const { SKU_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Reseller access for ${SKU_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'RULE_ACTIONS_CHANGED',
    label: 'Rule Actions Change',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME } = props;
      return `Rule actions for ${RULE_NAME} changed`;
    },
  },
  {
    value: 'CREATE_RULE',
    label: 'Rule Creation',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME } = props;
      return `Rule ${RULE_NAME} has been created`;
    },
  },
  {
    value: 'CHANGE_RULE_CRITERIA',
    label: 'Rule Criteria Change',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME } = props;
      return `Rule criteria for ${RULE_NAME} has been changed`;
    },
  },
  {
    value: 'DELETE_RULE',
    label: 'Rule Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME } = props;
      return `Rule ${RULE_NAME} has been deleted`;
    },
  },
  {
    value: 'RENAME_RULE',
    label: 'Rule Rename',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Rule ${OLD_VALUE} has been renamed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'RULE_STATUS_CHANGED',
    label: 'Rule Status Change',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Rule status for ${RULE_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ADD_SECONDARY_DOMAIN',
    label: 'Secondary Domain Creation',
    messageFormat: (props: EventMessageProps) => {
      const { SECONDARY_DOMAIN_NAME, DOMAIN_NAME } = props;
      return `An unverified ${SECONDARY_DOMAIN_NAME} created as a secondary domain of ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'REMOVE_SECONDARY_DOMAIN',
    label: 'Secondary Domain Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { SECONDARY_DOMAIN_NAME, DOMAIN_NAME } = props;
      return `${SECONDARY_DOMAIN_NAME} deleted as a secondary domain of ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'SKIP_SECONDARY_DOMAIN_MX',
    label: 'Secondary Domain MX Record Setup Skipped',
    messageFormat: (props: EventMessageProps) => {
      const { SECONDARY_DOMAIN_NAME, DOMAIN_NAME } = props;
      return `Skipped MX record setup of secondary domain ${SECONDARY_DOMAIN_NAME} of domain ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'VERIFY_SECONDARY_DOMAIN_MX',
    label: 'Secondary Domain MX Verification',
    messageFormat: (props: EventMessageProps) => {
      const { SECONDARY_DOMAIN_NAME, DOMAIN_NAME } = props;
      return `Verified MX records of secondary domain ${SECONDARY_DOMAIN_NAME} of domain ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'VERIFY_SECONDARY_DOMAIN',
    label: 'Secondary Domain Verification',
    messageFormat: (props: EventMessageProps) => {
      const { SECONDARY_DOMAIN_NAME, DOMAIN_NAME } = props;
      return `${SECONDARY_DOMAIN_NAME} verified as a secondary domain of ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'UPDATE_DOMAIN_SECONDARY_EMAIL',
    label: 'Secondary Email Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Secondary email for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_SSO_SETTINGS',
    label: 'SSO Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME } = props;
      return `SSO settings changed for ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'GENERATE_PIN',
    label: 'Support PIN Generation',
    messageFormat: () => {
      return `Customer support PIN generated`;
    },
  },
  {
    value: 'UPDATE_RULE',
    label: 'Update Rule',
    messageFormat: (props: EventMessageProps) => {
      const { RULE_NAME } = props;
      return `Rule ${RULE_NAME} has been updated`;
    },
  },

  // GMAIL
  {
    value: 'DROP_FROM_QUARANTINE',
    label: 'Drop from Quarantine',
    messageFormat: (props: EventMessageProps) => {
      const { QUARANTINE_NAME, EMAIL_LOG_SEARCH_MSG_ID } = props;
      return `A message with email message id of ${EMAIL_LOG_SEARCH_MSG_ID} was dropped from the ${QUARANTINE_NAME} quarantine.`;
    },
  },
  {
    value: 'EMAIL_LOG_SEARCH',
    label: 'Email Log Search',
    messageFormat: (props: EventMessageProps) => {
      const {
        EMAIL_LOG_SEARCH_START_DATE,
        EMAIL_LOG_SEARCH_END_DATE,
        EMAIL_LOG_SEARCH_SENDER,
        EMAIL_LOG_SEARCH_RECIPIENT,
        EMAIL_LOG_SEARCH_MSG_ID,
      } = props;
      return `An email log search is performed for logs from ${EMAIL_LOG_SEARCH_START_DATE} to ${EMAIL_LOG_SEARCH_END_DATE} with a sender of [${EMAIL_LOG_SEARCH_SENDER}], a recipient of [${EMAIL_LOG_SEARCH_RECIPIENT}], and an email message id of [${EMAIL_LOG_SEARCH_MSG_ID}]`;
    },
  },
  {
    value: 'EMAIL_UNDELETE',
    label: 'Email Restore',
    messageFormat: (props: EventMessageProps) => {
      const { START_DATE, END_DATE, USER_EMAIL } = props;
      return `Email restoration from ${START_DATE} to ${END_DATE} initiated for ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_EMAIL_SETTING',
    label: 'Email Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for email service in your organization changed from ${OLD_VALUE} to ${NEW_VALUE}}`;
    },
  },
  {
    value: 'CHANGE_GMAIL_SETTING',
    label: 'Gmail Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME } = props;
      return `Gmail setting ${SETTING_NAME} was modified`;
    },
  },
  {
    value: 'CREATE_GMAIL_SETTING',
    label: 'Gmail Setting Creation',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME } = props;
      return `New gmail setting ${SETTING_NAME} was added`;
    },
  },
  {
    value: 'DELETE_GMAIL_SETTING',
    label: 'Gmail Setting Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME } = props;
      return `Gmail setting ${SETTING_NAME} was deleted`;
    },
  },
  {
    value: 'REJECT_FROM_QUARANTINE',
    label: 'Reject from Quarantine',
    messageFormat: (props: EventMessageProps) => {
      const { EMAIL_LOG_SEARCH_MSG_ID, QUARANTINE_NAME } = props;
      return `A message with email message id of ${EMAIL_LOG_SEARCH_MSG_ID} was rejected with the default reject message from the ${QUARANTINE_NAME} quarantine.`;
    },
  },
  {
    value: 'RELEASE_FROM_QUARANTINE',
    label: 'Release from Quarantine',
    messageFormat: (props: EventMessageProps) => {
      const { EMAIL_LOG_SEARCH_MSG_ID, QUARANTINE_NAME } = props;
      return `A message with email message id of ${EMAIL_LOG_SEARCH_MSG_ID} was released from the ${QUARANTINE_NAME} quarantine.`;
    },
  },

  // GOOGLE GROUPS
  {
    value: 'WHITELISTED_GROUPS_UPDATED',
    label: 'Filtering groups updated',
    messageFormat: (props: EventMessageProps) => {
      const { WHITELISTED_GROUPS } = props;
      return `Filtering groups updated to ${WHITELISTED_GROUPS}`;
    },
  },
  {
    value: 'CREATE_GROUP',
    label: 'Group Creation',
    messageFormat: (props: EventMessageProps) => {
      const { GROUP_EMAIL } = props;
      return `Group ${GROUP_EMAIL} created`;
    },
  },
  {
    value: 'DELETE_GROUP',
    label: 'Group Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { GROUP_EMAIL } = props;
      return `Group ${GROUP_EMAIL} deleted`;
    },
  },
  {
    value: 'CHANGE_GROUP_DESCRIPTION',
    label: 'Group Description Change',
    messageFormat: (props: EventMessageProps) => {
      const { GROUP_EMAIL } = props;
      return `Description for group ${GROUP_EMAIL} changed`;
    },
  },
  {
    value: 'GROUP_LIST_DOWNLOAD',
    label: 'Group List Download',
    messageFormat: () => {
      return `Group list was downloaded as a CSV file`;
    },
  },
  {
    value: 'ADD_GROUP_MEMBER',
    label: 'Group Member Creation',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, GROUP_EMAIL } = props;
      return `User ${USER_EMAIL} created under group ${GROUP_EMAIL}`;
    },
  },
  {
    value: 'REMOVE_GROUP_MEMBER',
    label: 'Group Member Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, GROUP_EMAIL } = props;
      return `User ${USER_EMAIL} deleted from group ${GROUP_EMAIL}`;
    },
  },
  {
    value: 'UPDATE_GROUP_MEMBER',
    label: 'Group Member Update',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, GROUP_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Roles of the user ${USER_EMAIL} in group ${GROUP_EMAIL} updated from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_GROUP_MEMBER_DELIVERY_SETTINGS',
    label: 'Group Member Delivery Settings Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, GROUP_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `DeliverySettings of the user ${USER_EMAIL} in group ${GROUP_EMAIL} updated from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_GROUP_MEMBER_DELIVERY_SETTINGS_CAN_EMAIL_OVERRIDE',
    label: 'Group Member Delivery Settings Email Override Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, GROUP_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `DeliverySettings Email Override of the user ${USER_EMAIL} in group ${GROUP_EMAIL} updated from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'GROUP_MEMBER_BULK_UPLOAD',
    label: 'Group Members Bulk Upload',
    messageFormat: (props: EventMessageProps) => {
      const {
        GROUP_MEMBER_BULK_UPLOAD_TOTAL_NUMBER,
        GROUP_MEMBER_BULK_UPLOAD_FAILED_NUMBER,
      } = props;
      return `A total of ${GROUP_MEMBER_BULK_UPLOAD_TOTAL_NUMBER} members selected for upload. ${GROUP_MEMBER_BULK_UPLOAD_FAILED_NUMBER} out of ${GROUP_MEMBER_BULK_UPLOAD_TOTAL_NUMBER} members failed to be uploaded`;
    },
  },
  {
    value: 'GROUP_MEMBERS_DOWNLOAD',
    label: 'Group Members Download',
    messageFormat: () => {
      return `Group member list was downloaded as a CSV file`;
    },
  },
  {
    value: 'CHANGE_GROUP_NAME',
    label: 'Group Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { GROUP_EMAIL, NEW_VALUE } = props;
      return `Name of group ${GROUP_EMAIL} changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_GROUP_SETTING',
    label: 'Group Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, GROUP_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for group ${GROUP_EMAIL} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },

  // LICENSES SETTINGS
  {
    value: 'CHROME_APP_LICENSES_ENABLED',
    label: 'App License Policy Setting Changed',
    messageFormat: (props: EventMessageProps) => {
      const {
        APPLICATION_NAME,
        DISTRIBUTION_ENTITY_NAME,
        DISTRIBUTION_ENTITY_TYPE,
        CHROME_LICENSES_ENABLED,
      } = props;
      return `App license policy for ${APPLICATION_NAME} at ${DISTRIBUTION_ENTITY_NAME} ${DISTRIBUTION_ENTITY_TYPE} is now ${CHROME_LICENSES_ENABLED}`;
    },
  },
  {
    value: 'ORG_USERS_LICENSE_ASSIGNMENT',
    label: 'Assign Licenses to All Unassigned Users',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, NEW_VALUE, ORG_UNIT_NAME } = props;
      return `Licenses for ${PRODUCT_NAME} product and ${NEW_VALUE} sku were assigned to all unassigned users of ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'ORG_ALL_USERS_LICENSE_ASSIGNMENT',
    label: 'Assign Licenses to All Users',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, NEW_VALUE, ORG_UNIT_NAME } = props;
      return `Licenses for ${PRODUCT_NAME} product and ${NEW_VALUE} sku were assigned to all users of ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'USER_LICENSE_ASSIGNMENT',
    label: 'Assign User License',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, NEW_VALUE, USER_EMAIL } = props;
      return `A license for ${PRODUCT_NAME} product and ${NEW_VALUE} sku was assigned to the user ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_LICENSE_AUTO_ASSIGN',
    label: 'Auto Assign Licenses',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, NEW_VALUE, SKU_NAME } = props;
      return `License Auto Assign option changed to ${NEW_VALUE} for ${PRODUCT_NAME} product and ${SKU_NAME} sku`;
    },
  },
  {
    value: 'USER_LICENSE_REASSIGNMENT',
    label: 'Reassign User License',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, NEW_VALUE, OLD_VALUE, USER_EMAIL } = props;
      return `A license for ${PRODUCT_NAME} product and ${OLD_VALUE} sku was reassigned for user ${USER_EMAIL} to new sku ${NEW_VALUE}`;
    },
  },
  {
    value: 'ORG_LICENSE_REVOKE',
    label: 'Revoke Licenses to All Users',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, OLD_VALUE, ORG_UNIT_NAME } = props;
      return `Licenses for ${PRODUCT_NAME} product and ${OLD_VALUE} sku were removed from assigned users of ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'USER_LICENSE_REVOKE',
    label: 'Revoke User License',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, OLD_VALUE, USER_EMAIL } = props;
      return `A license for ${PRODUCT_NAME} product and ${OLD_VALUE} sku was revoked from user ${USER_EMAIL}`;
    },
  },
  {
    value: 'UPDATE_DYNAMIC_LICENSE',
    label: 'Update Auto Licensing',
    messageFormat: (props: EventMessageProps) => {
      const { PRODUCT_NAME, OLD_VALUE, NEW_VALUE, ORG_UNIT_NAME } = props;
      return `Auto Licensing settings for ${PRODUCT_NAME} product in ${ORG_UNIT_NAME} organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHROME_APP_USER_LICENSE_ASSIGNED',
    label: 'User license is assigned',
    messageFormat: (props: EventMessageProps) => {
      const { APP_LICENSE, USER_EMAIL } = props;
      return `License ${APP_LICENSE} is assigned to ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHROME_APP_USER_LICENSE_REVOKED',
    label: 'User license is revoked',
    messageFormat: (props: EventMessageProps) => {
      const { APP_LICENSE, USER_EMAIL } = props;
      return `License ${APP_LICENSE} is revoked for ${USER_EMAIL}`;
    },
  },

  // MOBILE DEVICES
  {
    value: 'ACTION_CANCELLED',
    label: 'Action Cancelled On Device',
    messageFormat: (props: EventMessageProps) => {
      const { ACTION_TYPE, ACTION_ID, DEVICE_TYPE, DEVICE_ID, USER_EMAIL } =
        props;
      return `${ACTION_TYPE} with id ${ACTION_ID} on device type ${DEVICE_TYPE} and id ${DEVICE_ID} was cancelled by user ${USER_EMAIL}`;
    },
  },
  {
    value: 'ACTION_REQUESTED',
    label: 'Action Requested On Device',
    messageFormat: (props: EventMessageProps) => {
      const { ACTION_TYPE, ACTION_ID, DEVICE_TYPE, DEVICE_ID, USER_EMAIL } =
        props;
      return `${ACTION_TYPE} with id ${ACTION_ID} on device type ${DEVICE_TYPE} and id ${DEVICE_ID} was requested by user ${USER_EMAIL}`;
    },
  },
  {
    value: 'ADD_MOBILE_CERTIFICATE',
    label: 'Add Mobile certificate',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_CERTIFICATE_COMMON_NAME } = props;
      return `Mobile certificate ${MOBILE_CERTIFICATE_COMMON_NAME} added for mobile devices in your organization`;
    },
  },
  {
    value: 'APPLE_DEP_SYNC_TRIGGERED',
    label: 'Apple DEP sync triggered by admin',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Apple DEP sync triggered by ${USER_EMAIL}`;
    },
  },
  {
    value: 'APPLE_DEP_TOKEN_SETUP_COMPLETE',
    label: 'Apple DEP token setup complete for customer',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Apple Device Enrollment tokens updated by ${USER_EMAIL}`;
    },
  },
  {
    value: 'COMPANY_DEVICES_BULK_CREATION',
    label: 'Bulk import of company owned devices',
    messageFormat: (props: EventMessageProps) => {
      const { NUMBER_OF_COMPANY_OWNED_DEVICES } = props;
      return `Details of ${NUMBER_OF_COMPANY_OWNED_DEVICES} company owned device(s) were imported`;
    },
  },
  {
    value: 'COMPANY_OWNED_DEVICE_BLOCKED',
    label: 'Company owned device blocked',
    messageFormat: (props: EventMessageProps) => {
      const { COMPANY_DEVICE_ID } = props;
      return `Company owned device ${COMPANY_DEVICE_ID} was blocked`;
    },
  },
  {
    value: 'COMPANY_DEVICE_DELETION',
    label: 'Company owned device deleted',
    messageFormat: (props: EventMessageProps) => {
      const { COMPANY_DEVICE_ID } = props;
      return `Company owned device ${COMPANY_DEVICE_ID} was deleted`;
    },
  },
  {
    value: 'COMPANY_OWNED_DEVICE_UNBLOCKED',
    label: 'Company owned device unblocked',
    messageFormat: (props: EventMessageProps) => {
      const { COMPANY_DEVICE_ID } = props;
      return `Company owned device ${COMPANY_DEVICE_ID} was unblocked`;
    },
  },
  {
    value: 'COMPANY_OWNED_DEVICE_WIPED',
    label: 'Company owned device wiped',
    messageFormat: (props: EventMessageProps) => {
      const { COMPANY_DEVICE_ID } = props;
      return `Company owned device ${COMPANY_DEVICE_ID} was wiped`;
    },
  },
  {
    value: 'CUSTOMER_USER_DEVICE_DELETION_EVENT',
    label: 'Customer user device deleted',
    messageFormat: (props: EventMessageProps) => {
      const { COMPANY_DEVICE_ID } = props;
      return `Customer user device ${COMPANY_DEVICE_ID} was deleted`;
    },
  },
  {
    value: 'CHANGE_MOBILE_APPLICATION_PERMISSION_GRANT',
    label: 'Mobile application permission grant change',
    messageFormat: (props: EventMessageProps) => {
      const {
        PERMISSION_GROUP_NAME,
        OLD_PERMISSION_GRANT_STATE,
        NEW_PERMISSION_GRANT_STATE,
        DEVICE_TYPE,
        MOBILE_APP_PACKAGE_ID,
        DISTRIBUTION_ENTITY_NAME,
        DISTRIBUTION_ENTITY_TYPE,
      } = props;
      return `Changed grant state of ${PERMISSION_GROUP_NAME} from ${OLD_PERMISSION_GRANT_STATE} to ${NEW_PERMISSION_GRANT_STATE} for ${DEVICE_TYPE} application ${MOBILE_APP_PACKAGE_ID} for ${DISTRIBUTION_ENTITY_NAME} ${DISTRIBUTION_ENTITY_TYPE}`;
    },
  },
  {
    value: 'CHANGE_MOBILE_APPLICATION_PRIORITY_ORDER',
    label: 'Mobile application priority order change',
    messageFormat: (props: EventMessageProps) => {
      const { DEVICE_TYPE, MOBILE_APP_PACKAGE_ID } = props;
      return `Priority order of ${DEVICE_TYPE} application ${MOBILE_APP_PACKAGE_ID} was changed`;
    },
  },
  {
    value: 'REMOVE_MOBILE_APPLICATION_FROM_WHITELIST',
    label: 'Mobile application removed from whitelist',
    messageFormat: (props: EventMessageProps) => {
      const {
        DEVICE_TYPE,
        MOBILE_APP_PACKAGE_ID,
        DISTRIBUTION_ENTITY_NAME,
        DISTRIBUTION_ENTITY_TYPE,
      } = props;
      return `${DEVICE_TYPE} application ${MOBILE_APP_PACKAGE_ID} is no longer whitelisted for ${DISTRIBUTION_ENTITY_NAME} ${DISTRIBUTION_ENTITY_TYPE}`;
    },
  },
  {
    value: 'CHANGE_MOBILE_APPLICATION_SETTINGS',
    label: 'Mobile application settings change',
    messageFormat: (props: EventMessageProps) => {
      const {
        SETTING_NAME,
        OLD_VALUE,
        NEW_VALUE,
        DEVICE_TYPE,
        MOBILE_APP_PACKAGE_ID,
        DISTRIBUTION_ENTITY_NAME,
        DISTRIBUTION_ENTITY_TYPE,
      } = props;
      return `Changed ${SETTING_NAME} app setting from ${OLD_VALUE} to ${NEW_VALUE} for ${DEVICE_TYPE} application ${MOBILE_APP_PACKAGE_ID} for ${DISTRIBUTION_ENTITY_NAME} ${DISTRIBUTION_ENTITY_TYPE}`;
    },
  },
  {
    value: 'ADD_MOBILE_APPLICATION_TO_WHITELIST',
    label: 'Mobile application whitelisted',
    messageFormat: (props: EventMessageProps) => {
      const {
        DEVICE_TYPE,
        MOBILE_APP_PACKAGE_ID,
        DISTRIBUTION_ENTITY_NAME,
        DISTRIBUTION_ENTITY_TYPE,
      } = props;
      return `${DEVICE_TYPE} application ${MOBILE_APP_PACKAGE_ID} is whitelisted for ${DISTRIBUTION_ENTITY_NAME} ${DISTRIBUTION_ENTITY_TYPE}`;
    },
  },
  {
    value: 'MOBILE_DEVICE_APPROVE',
    label: 'Mobile Device Approve',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Mobile device for ${USER_EMAIL} approved`;
    },
  },
  {
    value: 'MOBILE_DEVICE_BLOCK',
    label: 'Mobile Device Block',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Mobile device for ${USER_EMAIL} blocked`;
    },
  },
  {
    value: 'MOBILE_DEVICE_DELETE',
    label: 'Mobile Device Delete',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Mobile device for ${USER_EMAIL} deleted`;
    },
  },
  {
    value: 'MOBILE_DEVICE_WIPE',
    label: 'Mobile Device Wipe',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Mobile device for ${USER_EMAIL} wiped`;
    },
  },
  {
    value: 'CHANGE_MOBILE_SETTING',
    label: 'Mobile Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { SETTING_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `${SETTING_NAME} for mobile devices in your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_ADMIN_RESTRICTIONS_PIN',
    label: 'Mobile Setting Change: Administrator Restrictions Pin',
    messageFormat: () => {
      return `Administrator restrictions pin for mobile devices in your organization changed`;
    },
  },
  {
    value: 'CHANGE_MOBILE_WIRELESS_NETWORK',
    label: 'Mobile Wireless Network Change',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_WIRELESS_NETWORK_NAME } = props;
      return `Mobile wireless network ${MOBILE_WIRELESS_NETWORK_NAME} changed for mobile devices in your organization`;
    },
  },
  {
    value: 'ADD_MOBILE_WIRELESS_NETWORK',
    label: 'Mobile Wireless Network Creation',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_WIRELESS_NETWORK_NAME } = props;
      return `Mobile wireless network ${MOBILE_WIRELESS_NETWORK_NAME} created for mobile devices in your organization`;
    },
  },
  {
    value: 'REMOVE_MOBILE_WIRELESS_NETWORK',
    label: 'Mobile Wireless Network Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_WIRELESS_NETWORK_NAME } = props;
      return `Mobile wireless network ${MOBILE_WIRELESS_NETWORK_NAME} deleted for mobile devices in your organization`;
    },
  },
  {
    value: 'CHANGE_MOBILE_WIRELESS_NETWORK_PASSWORD',
    label: 'Mobile Wireless Network Password Change',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_WIRELESS_NETWORK_NAME } = props;
      return `Password changed for mobile wireless network ${MOBILE_WIRELESS_NETWORK_NAME} in your organization`;
    },
  },
  {
    value: 'REMOVE_MOBILE_CERTIFICATE',
    label: 'Remove Mobile certificate',
    messageFormat: (props: EventMessageProps) => {
      const { MOBILE_CERTIFICATE_COMMON_NAME } = props;
      return `Mobile certificate ${MOBILE_CERTIFICATE_COMMON_NAME} removed for mobile devices in your organization`;
    },
  },
  {
    value: 'ENROLL_FOR_GOOGLE_DEVICE_MANAGEMENT',
    label: 'Use Google Device Management',
    messageFormat: () => {
      return `Enrolled for Google Device Management`;
    },
  },
  {
    value: 'USE_GOOGLE_MOBILE_MANAGEMENT',
    label: 'Use Google Mobile Management',
    messageFormat: () => {
      return `You have selected Google Mobile Management to manage all your mobile devices`;
    },
  },
  {
    value: 'USE_GOOGLE_MOBILE_MANAGEMENT_FOR_NON_IOS',
    label: 'Use Google Mobile Management for Android and Active Sync devices',
    messageFormat: () => {
      return `You have selected Google Mobile Management to manage your Android and Active Sync devices`;
    },
  },
  {
    value: 'USE_GOOGLE_MOBILE_MANAGEMENT_FOR_IOS',
    label: 'Use Google Mobile Management for iOS devices',
    messageFormat: () => {
      return `You have selected Google Mobile Management to manage your iOS devices`;
    },
  },
  {
    value: 'MOBILE_ACCOUNT_WIPE',
    label: 'Wipe Mobile Account',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Mobile account for ${USER_EMAIL} has been wiped`;
    },
  },
  {
    value: 'MOBILE_DEVICE_CANCEL_WIPE_THEN_APPROVE',
    label: 'Wipe On Mobile Cancel And Approve Device',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Wipe on mobile device for ${USER_EMAIL} was cancelled and the device was approved`;
    },
  },
  {
    value: 'MOBILE_DEVICE_CANCEL_WIPE_THEN_BLOCK',
    label: 'Wipe On Mobile Cancel And Block Device',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Wipe on mobile device for ${USER_EMAIL} was cancelled and the device has been blocked`;
    },
  },

  // ORGANIZATION SETTINGS
  {
    value: 'CHROME_LICENSES_ENABLED',
    label: 'App License Policy Changed',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, ORG_UNIT_NAME, CHROME_LICENSES_ENABLED } =
        props;
      return `App license policy for ${APPLICATION_NAME} at org unit ${ORG_UNIT_NAME} is now ${CHROME_LICENSES_ENABLED}`;
    },
  },
  {
    value: 'CHROME_APPLICATION_LICENSE_RESERVATION_CREATED',
    label: 'Application License Reservation Created',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, ORG_UNIT_NAME, NEW_VALUE, SKU_NAME } = props;
      return `${NEW_VALUE} app licenses reserved to ${ORG_UNIT_NAME} for ${APPLICATION_NAME} ${SKU_NAME}`;
    },
  },
  {
    value: 'CHROME_APPLICATION_LICENSE_RESERVATION_DELETED',
    label: 'Application License Reservation Deleted',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, ORG_UNIT_NAME, SKU_NAME } = props;
      return `App license reservation at ${ORG_UNIT_NAME} for ${APPLICATION_NAME} ${SKU_NAME} deleted`;
    },
  },
  {
    value: 'CHROME_APPLICATION_LICENSE_RESERVATION_UPDATED',
    label: 'App License Reservation Updated',
    messageFormat: (props: EventMessageProps) => {
      const {
        APPLICATION_NAME,
        ORG_UNIT_NAME,
        OLD_VALUE,
        NEW_VALUE,
        SKU_NAME,
      } = props;
      return `App license reservation at ${ORG_UNIT_NAME} for ${APPLICATION_NAME} ${SKU_NAME} updated from ${OLD_VALUE} to ${NEW_VALUE} licenses`;
    },
  },
  {
    value: 'CREATE_DEVICE_ENROLLMENT_TOKEN',
    label: 'Create enrollment token',
    messageFormat: (props: EventMessageProps) => {
      const { FULL_ORG_UNIT_PATH } = props;
      return `Generated a new enrollment token for ${FULL_ORG_UNIT_PATH}`;
    },
  },
  {
    value: 'ASSIGN_CUSTOM_LOGO',
    label: 'Custom Logo Assign',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `New custom logo assigned for org unit ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'UNASSIGN_CUSTOM_LOGO',
    label: 'Custom Logo Unassign',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `Custom logo unassigned for org unit ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'CREATE_ENROLLMENT_TOKEN',
    label: 'Enrollment Token Creation',
    messageFormat: (props: EventMessageProps) => {
      const { FULL_ORG_UNIT_PATH } = props;
      return `A new enrollment token is generated for ${FULL_ORG_UNIT_PATH}`;
    },
  },
  {
    value: 'REVOKE_ENROLLMENT_TOKEN',
    label: 'Enrollment Token Revocation',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `The enrollment token of ${ORG_UNIT_NAME} has been revoked`;
    },
  },
  {
    value: 'CHROME_LICENSES_ALLOWED',
    label: 'Licenses allowed or not at an org unit',
    messageFormat: (props: EventMessageProps) => {
      const { APPLICATION_NAME, ORG_UNIT_NAME, CHROME_LICENSES_ALLOWED } =
        props;
      return `Licenses allowed policy is ${CHROME_LICENSES_ALLOWED} for app ${APPLICATION_NAME} at org unit ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'CREATE_ORG_UNIT',
    label: 'OrgUnit Creation',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `Org Unit ${ORG_UNIT_NAME} created`;
    },
  },
  {
    value: 'REMOVE_ORG_UNIT',
    label: 'OrgUnit Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `Org Unit ${ORG_UNIT_NAME} deleted`;
    },
  },
  {
    value: 'EDIT_ORG_UNIT_DESCRIPTION',
    label: 'OrgUnit Description Change',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `Description of ${ORG_UNIT_NAME} changed`;
    },
  },
  {
    value: 'MOVE_ORG_UNIT',
    label: 'OrgUnit Move',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, NEW_VALUE } = props;
      return `Org Unit ${ORG_UNIT_NAME} moved to parent ${NEW_VALUE}`;
    },
  },
  {
    value: 'EDIT_ORG_UNIT_NAME',
    label: 'OrgUnit Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Name of ${OLD_VALUE} changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'REVOKE_DEVICE_ENROLLMENT_TOKEN',
    label: 'Revoke enrollment token',
    messageFormat: (props: EventMessageProps) => {
      const { FULL_ORG_UNIT_PATH } = props;
      return `Revoked the enrollment token of ${FULL_ORG_UNIT_PATH}`;
    },
  },
  {
    value: 'TOGGLE_SERVICE_ENABLED',
    label: 'Service Change',
    messageFormat: (props: EventMessageProps) => {
      const { SERVICE_NAME, ORG_UNIT_NAME, NEW_VALUE } = props;
      return `Service ${SERVICE_NAME} changed to ${NEW_VALUE} for ${ORG_UNIT_NAME} organizational unit in your organization`;
    },
  },

  //Security
  {
    value: 'CHANGE_CAA_APP_ASSIGNMENTS',
    label: '(Context-aware access) Access level assignment changed for an app',
    messageFormat: (props: EventMessageProps) => {
      const {
        TARGET_ENTITY_TYPE,
        TARGET_ENTITY_NAME,
        CAA_ASSIGNMENTS_OLD,
        CAA_ENFORCEMENT_ENDPOINTS_OLD,
        APPLICATION_NAME,
        CAA_ASSIGNMENTS_NEW,
        CAA_ENFORCEMENT_ENDPOINTS_NEW,
      } = props;
      return `For ${TARGET_ENTITY_TYPE} [${TARGET_ENTITY_NAME}]:Before:Access level [${CAA_ASSIGNMENTS_OLD}] applied to [${CAA_ENFORCEMENT_ENDPOINTS_OLD}] of [${APPLICATION_NAME}].After:Access level [${CAA_ASSIGNMENTS_NEW}] applied to [${CAA_ENFORCEMENT_ENDPOINTS_NEW}] of [${APPLICATION_NAME}].`;
    },
  },
  {
    value: 'UNDERAGE_BLOCK_ALL_THIRD_PARTY_API_ACCESS',
    label:
      'All access to unconfigured third-party apps blocked for users under 18',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `All access to unconfigured third-party apps blocked for users under 18 for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'BLOCK_ALL_THIRD_PARTY_API_ACCESS',
    label: 'All third party API access blocked',
    messageFormat: () => {
      return `All third party API access blocked`;
    },
  },
  {
    value: 'UNBLOCK_ALL_THIRD_PARTY_API_ACCESS',
    label: 'All third party API access unblocked',
    messageFormat: () => {
      return `All third party API access unblocked`;
    },
  },
  {
    value: 'ALLOW_STRONG_AUTHENTICATION',
    label: 'Allow 2-Step Verification',
    messageFormat: (props: EventMessageProps) => {
      const { DOMAIN_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `Allow 2-Step Verification has been set from ${OLD_VALUE} to ${NEW_VALUE} for ${DOMAIN_NAME}`;
    },
  },
  {
    value: 'UNDERAGE_SIGN_IN_ONLY_THIRD_PARTY_API_ACCESS',
    label:
      'Allow Google Sign-in only access to unconfigured third-party apps for users under 18',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME } = props;
      return `Allow Google Sign-in only access to unconfigured third-party apps for users under 18 for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'SIGN_IN_ONLY_THIRD_PARTY_API_ACCESS',
    label: 'Allow Google Sign-in only third party API access',
    messageFormat: () => {
      return `Allow Google Sign-in only third party API access`;
    },
  },
  {
    value: 'ALLOW_SERVICE_FOR_OAUTH2_ACCESS',
    label: 'API Access Allowed',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_SERVICE_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_SERVICE_NAME} API Access is allowed for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'DISALLOW_SERVICE_FOR_OAUTH2_ACCESS',
    label: 'API Access Blocked',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_SERVICE_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_SERVICE_NAME} API Access is blocked for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'CHANGE_APP_ACCESS_SETTINGS_COLLECTION_ID',
    label: 'App access settings collection id change',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `App Access Settings Collection for the org unit ${ORG_UNIT_NAME} has changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ADD_TO_BLOCKED_OAUTH2_APPS',
    label: 'App added to Blocked list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} added to the blocked list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'ADD_TO_LIMITED_OAUTH2_APPS',
    label: 'App added to Limited list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} added to the limited list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'REMOVE_FROM_TRUSTED_OAUTH2_APPS',
    label: 'App no longer trusted',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} no longer trusted for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'REMOVE_FROM_BLOCKED_OAUTH2_APPS',
    label: 'App removed from Blocked list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} removed from the Blocked list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'REMOVE_FROM_LIMITED_OAUTH2_APPS',
    label: 'App removed from Limited list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} removed from the limited list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'ADD_TO_TRUSTED_OAUTH2_APPS',
    label: 'App trusted',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_APP_NAME, ORG_UNIT_NAME } = props;
      return `${OAUTH2_APP_NAME} trusted for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'MULTIPLE_ADD_TO_BLOCKED_OAUTH2_APPS',
    label: 'Apps added to Blocked list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_NUM_APPS, ORG_UNIT_NAME } = props;
      return `${OAUTH2_NUM_APPS} apps added to the Blocked list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'MULTIPLE_ADD_TO_LIMITED_OAUTH2_APPS',
    label: 'Apps added to Limited list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_NUM_APPS, ORG_UNIT_NAME } = props;
      return `${OAUTH2_NUM_APPS} apps added to the Limited list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'MULTIPLE_ADD_TO_TRUSTED_OAUTH2_APPS',
    label: 'Apps added to Trusted list',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_NUM_APPS, ORG_UNIT_NAME } = props;
      return `${OAUTH2_NUM_APPS} apps added to the Trusted list for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'OAUTH_APPS_BULK_UPLOAD',
    label: 'Apps lists bulk upload',
    messageFormat: (props: EventMessageProps) => {
      const {
        BULK_UPLOAD_SUCCESS_OAUTH_APPS_NUMBER,
        BULK_UPLOAD_TOTAL_OAUTH_APPS_NUMBER,
      } = props;
      return `${BULK_UPLOAD_SUCCESS_OAUTH_APPS_NUMBER} of ${BULK_UPLOAD_TOTAL_OAUTH_APPS_NUMBER} rows successfully uploaded`;
    },
  },
  {
    value: 'OAUTH_APPS_BULK_UPLOAD_NOTIFICATION_SENT',
    label: 'Apps lists bulk upload notification',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Notification of bulk upload for apps list sent to ${USER_EMAIL}`;
    },
  },
  {
    value: 'BLOCK_ON_DEVICE_ACCESS',
    label: 'Block on Device Access',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_SERVICE_NAME, ORG_UNIT_NAME } = props;
      return `Block on device ${OAUTH2_SERVICE_NAME} access for ${ORG_UNIT_NAME}`;
    },
  },
  {
    value: 'CHANGE_TWO_STEP_VERIFICATION_ENROLLMENT_PERIOD_DURATION',
    label: 'Change 2-Step Verification Enrollment Period Duration',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `2-Step verification enrollment period duration for ${ORG_UNIT_NAME} has been changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_TWO_STEP_VERIFICATION_FREQUENCY',
    label: 'Change 2-Step Verification Frequency',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `2-step verification frequency for ${ORG_UNIT_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_TWO_STEP_VERIFICATION_GRACE_PERIOD_DURATION',
    label: 'Change 2-Step Verification Grace Period Duration',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, OLD_VALUE, NEW_VALUE } = props;
      return `2-step verification grace period duration for ${ORG_UNIT_NAME} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_TWO_STEP_VERIFICATION_START_DATE',
    label: 'Change 2-Step Verification Start Date',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `2-step verification start date has been changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_ALLOWED_TWO_STEP_VERIFICATION_METHODS',
    label: 'Change Allowed 2-step Verification Methods',
    messageFormat: (props: EventMessageProps) => {
      const { ORG_UNIT_NAME, ALLOWED_TWO_STEP_VERIFICATION_METHOD } = props;
      return `2-step verification allowed 2-step verification methods for ${ORG_UNIT_NAME} changed to ${ALLOWED_TWO_STEP_VERIFICATION_METHOD}`;
    },
  },
  {
    value: 'TOGGLE_CAA_ENABLEMENT',
    label: 'Context Aware Access Enablement',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE } = props;
      return `Context Aware Access has been ${NEW_VALUE}.`;
    },
  },
  {
    value: 'CHANGE_CAA_ERROR_MESSAGE',
    label: 'Context Aware Access Error Message Change',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, ORG_UNIT_NAME } = props;
      return `Error message has been changed to [${NEW_VALUE}]. (OrgUnit Name: ${ORG_UNIT_NAME})`;
    },
  },
  {
    value: 'UNTRUST_DOMAIN_OWNED_OAUTH2_APPS',
    label: 'Domain Owned Apps not trusted',
    messageFormat: () => {
      return `Domain Owned Apps removed from trusted list
      `;
    },
  },
  {
    value: 'TRUST_DOMAIN_OWNED_OAUTH2_APPS',
    label: 'Domain Owned Apps trusted',
    messageFormat: () => {
      return `Domain Owned Apps added to trusted list
      `;
    },
  },
  {
    value: 'ENABLE_NON_ADMIN_USER_PASSWORD_RECOVERY',
    label: 'Enable Non-Admin User Password Recovery',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, ORG_UNIT_NAME, OLD_VALUE } = props;
      return `Enable non-admin user password recovery setting in ${ORG_UNIT_NAME} organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ENFORCE_STRONG_AUTHENTICATION',
    label: 'Enforce 2-Step Verification',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, SETTING_NAME, OLD_VALUE } = props;
      return `${SETTING_NAME} in security settings for your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UPDATE_ERROR_MSG_FOR_RESTRICTED_OAUTH2_APPS',
    label: 'Error message for restricted OAuth2 apps updated',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE } = props;
      return `Error message for restricted OAuth2 apps for your organization updated from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'WEAK_PROGRAMMATIC_LOGIN_SETTINGS_CHANGED',
    label: 'Less Secure Apps Access setting changed',
    messageFormat: (props: EventMessageProps) => {
      const { NEW_VALUE, OLD_VALUE, ORG_UNIT_NAME } = props;
      return `Setting changed for ${ORG_UNIT_NAME} organization unit from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'SESSION_CONTROL_SETTINGS_CHANGE',
    label: 'Session Control Settings Change',
    messageFormat: (props: EventMessageProps) => {
      const {
        REAUTH_APPLICATION,
        REAUTH_SETTING_OLD,
        REAUTH_SETTING_NEW,
        ORG_UNIT_NAME,
      } = props;
      return `Session Control Settings updated for ${REAUTH_APPLICATION} from ${REAUTH_SETTING_OLD} to ${REAUTH_SETTING_NEW}. (OrgUnit Name: ${ORG_UNIT_NAME})`;
    },
  },
  {
    value: 'CHANGE_SESSION_LENGTH',
    label: 'Session length changed',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE } = props;
      return `Session length has been changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UNBLOCK_ON_DEVICE_ACCESS',
    label: 'Unblock on Device Access',
    messageFormat: (props: EventMessageProps) => {
      const { OAUTH2_SERVICE_NAME, ORG_UNIT_NAME } = props;
      return `Unblock on device ${OAUTH2_SERVICE_NAME} access for ${ORG_UNIT_NAME}`;
    },
  },

  // GOOGLE SITES
  {
    value: 'ADD_WEB_ADDRESS',
    label: 'Add Web Address',
    messageFormat: (props: EventMessageProps) => {
      const { WEB_ADDRESS, SITE_LOCATION } = props;
      return `${WEB_ADDRESS} added as web address for site location ${SITE_LOCATION}`;
    },
  },
  {
    value: 'DELETE_WEB_ADDRESS',
    label: 'Delete Web Address',
    messageFormat: (props: EventMessageProps) => {
      const { WEB_ADDRESS, SITE_LOCATION } = props;
      return `${WEB_ADDRESS} deleted as web address for site location ${SITE_LOCATION}`;
    },
  },
  {
    value: 'CHANGE_SITES_SETTING',
    label: 'Sites Setting Change',
    messageFormat: (props: EventMessageProps) => {
      const { OLD_VALUE, NEW_VALUE, SETTING_NAME } = props;
      return `${SETTING_NAME} for sites in your organization changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_SITES_WEB_ADDRESS_MAPPING_UPDATES',
    label: 'Sites web address mapping change',
    messageFormat: (props: EventMessageProps) => {
      const { SERVICE_NAME, WEB_ADDRESS, SITE_LOCATION } = props;
      return `${SERVICE_NAME} this ${WEB_ADDRESS} as web address for site location ${SITE_LOCATION}`;
    },
  },
  {
    value: 'VIEW_SITE_DETAILS',
    label: 'Viewed Google Site details',
    messageFormat: (props: EventMessageProps) => {
      const { SITE_NAME } = props;
      return `Admin viewed the site details of ${SITE_NAME}`;
    },
  },

  // USER

  {
    value: 'DELETE_2SV_SCRATCH_CODES',
    label: '2-step Verification Scratch Codes Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `2-step verification scratch codes of the user ${USER_EMAIL} deleted`;
    },
  },
  {
    value: 'GENERATE_2SV_SCRATCH_CODES',
    label: '2-step Verification Scratch Codes Generate',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `New 2-step verification scratch codes generated for the user ${USER_EMAIL}`;
    },
  },
  {
    value: 'REVOKE_3LO_DEVICE_TOKENS',
    label: '3-legged OAuth Device Tokens Revoke',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, DEVICE_TYPE, DEVICE_ID } = props;
      return `3-legged OAuth tokens issued by user ${USER_EMAIL} for the device type ${DEVICE_TYPE} and id ${DEVICE_ID} were revoked`;
    },
  },
  {
    value: 'REVOKE_3LO_TOKEN',
    label: '3-legged OAuth Token Revoke',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, APP_ID } = props;
      return `3-legged OAuth tokens issued by user ${USER_EMAIL} for application ${APP_ID} were revoked`;
    },
  },
  {
    value: 'ACCEPT_USER_INVITATION',
    label: 'Accept User Invite',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `User invitation accepted for user: ${USER_EMAIL}`;
    },
  },
  {
    value: 'ADD_RECOVERY_EMAIL',
    label: 'Add Recovery Email',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery email added for ${USER_EMAIL}`;
    },
  },
  {
    value: 'ADD_RECOVERY_PHONE',
    label: 'Add Recovery Phone',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery phone added for ${USER_EMAIL}`;
    },
  },
  {
    value: 'GRANT_ADMIN_PRIVILEGE',
    label: 'Admin Privileges Grant',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Admin privileges granted to ${USER_EMAIL}`;
    },
  },
  {
    value: 'REVOKE_ADMIN_PRIVILEGE',
    label: 'Admin Privileges Revoke',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Admin privileges revoked from ${USER_EMAIL}`;
    },
  },
  {
    value: 'REVOKE_ASP',
    label: 'Application Specific Password Revoke',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, ASP_ID } = props;
      return `Application specific password with Id ${ASP_ID} issued by user ${USER_EMAIL} revoked`;
    },
  },
  {
    value: 'TOGGLE_AUTOMATIC_CONTACT_SHARING',
    label: 'Automatic Contact Share Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `Automatic contact sharing for ${USER_EMAIL} changed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'BULK_UPLOAD',
    label: 'Bulk Upload',
    messageFormat: (props: EventMessageProps) => {
      const { BULK_UPLOAD_FAIL_USERS_NUMBER, BULK_UPLOAD_TOTAL_USERS_NUMBER } =
        props;
      return `${BULK_UPLOAD_TOTAL_USERS_NUMBER} users selected for upload to your organization. ${BULK_UPLOAD_FAIL_USERS_NUMBER} out of ${BULK_UPLOAD_TOTAL_USERS_NUMBER} users were not uploaded.`;
    },
  },
  {
    value: 'BULK_UPLOAD_NOTIFICATION_SENT',
    label: 'Bulk Upload Notification',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Notification of bulk users upload sent to ${USER_EMAIL}`;
    },
  },
  {
    value: 'CANCEL_USER_INVITE',
    label: 'Cancel User Invite',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Invite to ${USER_EMAIL} cancelled`;
    },
  },
  {
    value: 'CHANGE_USER_CUSTOM_FIELD',
    label: 'Change Custom Attribute',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, USER_CUSTOM_FIELD, OLD_VALUE, NEW_VALUE } = props;
      return `${USER_CUSTOM_FIELD} changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_EXTERNAL_ID',
    label: 'Change External Id',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `External Ids changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_GENDER',
    label: 'Change Gender',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Gender changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_IM',
    label: 'Change IM',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `IMs changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'ENABLE_USER_IP_WHITELIST',
    label: 'Change IP Whitelist',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `IP whitelist changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_KEYWORD',
    label: 'Change Keyword',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Keywords changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_LANGUAGE',
    label: 'Change Language',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Languages changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_LOCATION',
    label: 'Change Location',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Locations changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_ORGANIZATION',
    label: 'Change Organization',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Organizations changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_PHONE_NUMBER',
    label: 'Change Phone Numbers',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Phone Numbers changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_RECOVERY_EMAIL',
    label: 'Change Recovery Email',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery email changed for ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_RECOVERY_PHONE',
    label: 'Change Recovery Phone',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery phone changed for ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_USER_RELATION',
    label: 'Change Relation',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Relations changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CHANGE_USER_ADDRESS',
    label: 'Change User Address',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Addresses changed for ${USER_EMAIL} from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'CREATE_EMAIL_MONITOR',
    label: 'Create an email monitor',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, EMAIL_MONITOR_DEST_EMAIL, END_DATE_TIME } = props;
      return `Created an email monitor for ${USER_EMAIL} to ${EMAIL_MONITOR_DEST_EMAIL} that will expire on ${END_DATE_TIME}`;
    },
  },
  {
    value: 'CREATE_DATA_TRANSFER_REQUEST',
    label: 'Data transfer request created',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, DESTINATION_USER_EMAIL, APPLICATION_NAME } = props;
      return `Data transfer request created from ${USER_EMAIL} to ${DESTINATION_USER_EMAIL} for apps ${APPLICATION_NAME}`;
    },
  },
  {
    value: 'GRANT_DELEGATED_ADMIN_PRIVILEGES',
    label: 'Delegated Admin Privileges Grant',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `${USER_EMAIL} assigned ${NEW_VALUE} admin privileges`;
    },
  },
  {
    value: 'DELETE_ACCOUNT_INFO_DUMP',
    label: 'Delete account information dump',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, REQUEST_ID } = props;
      return `Deleted account and login information dump for ${USER_EMAIL} and request ID ${REQUEST_ID}`;
    },
  },
  {
    value: 'DELETE_EMAIL_MONITOR',
    label: 'Delete an email monitor',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, EMAIL_MONITOR_DEST_EMAIL } = props;
      return `Deleted an email monitor for ${USER_EMAIL} to ${EMAIL_MONITOR_DEST_EMAIL}`;
    },
  },
  {
    value: 'DELETE_MAILBOX_DUMP',
    label: 'Delete mailbox dump',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, REQUEST_ID } = props;
      return `Deleted mailbox dump for ${USER_EMAIL} and request ID ${REQUEST_ID}`;
    },
  },
  {
    value: 'DELETE_PROFILE_PHOTO',
    label: 'Delete Profile Photo',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Profile photo of ${USER_EMAIL} has been deleted`;
    },
  },
  {
    value: 'ADD_DISPLAY_NAME',
    label: 'Display Name Added',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, USER_DISPLAY_NAME } = props;
      return `${USER_DISPLAY_NAME} added as a display name of ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_DISPLAY_NAME',
    label: 'Display Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Display name of ${USER_EMAIL} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'REMOVE_DISPLAY_NAME',
    label: 'Display Name Removed',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, USER_DISPLAY_NAME } = props;
      return `${USER_DISPLAY_NAME} removed as a display name of ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_FIRST_NAME',
    label: 'First Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `First name of ${USER_EMAIL} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'GMAIL_RESET_USER',
    label: 'Gmail Account Reset',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Gmail account of ${USER_EMAIL} reset`;
    },
  },
  {
    value: 'CHANGE_LAST_NAME',
    label: 'Last Name Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Last name of ${USER_EMAIL} changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'MAIL_ROUTING_DESTINATION_ADDED',
    label: 'Mail Routing Destination Creation',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `User ${USER_EMAIL} has received the following individual mail routing destination: ${NEW_VALUE}`;
    },
  },
  {
    value: 'MAIL_ROUTING_DESTINATION_REMOVED',
    label: 'Mail Routing Destination Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE } = props;
      return `User ${USER_EMAIL} has had the following individual mail routing destination removed: ${OLD_VALUE}`;
    },
  },
  {
    value: 'ADD_NICKNAME',
    label: 'Nickname Creation',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, USER_NICKNAME } = props;
      return `${USER_NICKNAME} created as a nickname of ${USER_EMAIL}`;
    },
  },
  {
    value: 'REMOVE_NICKNAME',
    label: 'Nickname Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, USER_NICKNAME } = props;
      return `${USER_NICKNAME} deleted as a nickname of ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_PASSWORD',
    label: 'Password Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Password changed for ${USER_EMAIL}`;
    },
  },
  {
    value: 'CHANGE_PASSWORD_ON_NEXT_LOGIN',
    label: 'Password Change on Next Login',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, OLD_VALUE, NEW_VALUE } = props;
      return `Password change requirement for ${USER_EMAIL} on next login changed from ${OLD_VALUE} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'DOWNLOAD_PENDING_INVITES_LIST',
    label: 'Pending Invites List Download',
    messageFormat: () => {
      return `Pending Invites List was downloaded as a CSV file}`;
    },
  },
  {
    value: 'REMOVE_RECOVERY_EMAIL',
    label: 'Remove Recovery Email',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery email removed for ${USER_EMAIL}`;
    },
  },
  {
    value: 'REMOVE_RECOVERY_PHONE',
    label: 'Remove Recovery Phone',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Recovery phone removed for ${USER_EMAIL}`;
    },
  },
  {
    value: 'REQUEST_ACCOUNT_INFO',
    label: 'Request account information',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Requested account and login information for ${USER_EMAIL}`;
    },
  },
  {
    value: 'REQUEST_MAILBOX_DUMP',
    label: 'Request mailbox dump',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Requested mailbox dump for ${USER_EMAIL}`;
    },
  },
  {
    value: 'RESEND_USER_INVITE',
    label: 'Resend User Invite',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Invite email to ${USER_EMAIL} resent`;
    },
  },
  {
    value: 'RESET_SIGNIN_COOKIES',
    label: 'Reset Cookies and Forced Relogin',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Cookies reset for ${USER_EMAIL} and forced re-login`;
    },
  },
  {
    value: 'SECURITY_KEY_REGISTERED_FOR_USER',
    label: 'Security Key Registered For User',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Security key registered for ${USER_EMAIL}`;
    },
  },
  {
    value: 'REVOKE_SECURITY_KEY',
    label: 'Security Key Revoke',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `A security key enrolled for user ${USER_EMAIL} for 2-step verification was revoked`;
    },
  },
  {
    value: 'USER_INVITE',
    label: 'Send User Invite',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} invited to join your organization`;
    },
  },
  {
    value: 'VIEW_TEMP_PASSWORD',
    label: 'Temporary Password Viewed',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Temporary password for user ${USER_EMAIL} viewed by the admin`;
    },
  },
  {
    value: 'TURN_OFF_2_STEP_VERIFICATION',
    label: 'Turn off 2-step verification',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `2-step verification has been turned off for the user ${USER_EMAIL}`;
    },
  },
  {
    value: 'UNBLOCK_USER_SESSION',
    label: 'Unblock User Session',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `User ${USER_EMAIL} unblocked by temporarily disabling login challenge`;
    },
  },
  {
    value: 'UNMANAGED_USERS_BULK_UPLOAD',
    label: 'Unmanaged Users Bulk Upload',
    messageFormat: (props: EventMessageProps) => {
      const { BULK_UPLOAD_TOTAL_USERS_NUMBER, BULK_UPLOAD_FAIL_USERS_NUMBER } =
        props;
      return `A total of ${BULK_UPLOAD_TOTAL_USERS_NUMBER} unmanaged users selected for upload. ${BULK_UPLOAD_FAIL_USERS_NUMBER} out of ${BULK_UPLOAD_TOTAL_USERS_NUMBER} users failed to be uploaded.`;
    },
  },
  {
    value: 'DOWNLOAD_UNMANAGED_USERS_LIST',
    label: 'Unmanaged Users List Download',
    messageFormat: () => {
      return `Unmanaged Users list was downloaded as a CSV file`;
    },
  },
  {
    value: 'UPDATE_PROFILE_PHOTO',
    label: 'Update Profile Photo',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Profile photo of ${USER_EMAIL} has been updated`;
    },
  },
  {
    value: 'UNENROLL_USER_FROM_TITANIUM',
    label: 'User Advanced Protection Unenroll',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `User ${USER_EMAIL} unenrolled from Advanced Protection`;
    },
  },
  {
    value: 'ARCHIVE_USER',
    label: 'User Archival',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} archived`;
    },
  },
  {
    value: 'UPDATE_BIRTHDATE',
    label: 'User BirthDate Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, BIRTHDATE } = props;
      return `The birth date for ${USER_EMAIL} changed to ${BIRTHDATE}`;
    },
  },
  {
    value: 'CREATE_USER',
    label: 'User Creation',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} created`;
    },
  },
  {
    value: 'ROLE_PERMISSION_CHANGE',
    label: 'Permission Change',
    messageFormat: (_props: EventMessageProps) => {
      return `Permissions for a role changed`;
    },
  },
  {
    value: 'ROLE_MEMBER_UPDATE',
    label: 'Role Member Update',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} role membership updated`;
    },
  },
  {
    value: 'DELETE_USER',
    label: 'User Deletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} deleted`;
    },
  },
  {
    value: 'DOWNGRADE_USER_FROM_GPLUS',
    label: 'User Downgrade From Google+',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} was downgraded from Google+`;
    },
  },
  {
    value: 'USER_ENROLLED_IN_TWO_STEP_VERIFICATION',
    label: 'User Enrolled In 2-Step Verification',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} enrolled in 2-step verification`;
    },
  },
  {
    value: 'DOWNLOAD_USERLIST_CSV',
    label: 'User List Download',
    messageFormat: () => {
      return `User list was downloaded as a CSV file`;
    },
  },
  {
    value: 'MOVE_USER_TO_ORG_UNIT',
    label: 'User OrgUnit Change',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, ORG_UNIT_NAME, NEW_VALUE } = props;
      return `${USER_EMAIL} moved from ${ORG_UNIT_NAME} to ${NEW_VALUE}`;
    },
  },
  {
    value: 'USER_PUT_IN_TWO_STEP_VERIFICATION_GRACE_PERIOD',
    label: 'User Put In 2-Step Verification Grace Period',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `2-step verification grace period has been enabled on ${USER_EMAIL} till ${NEW_VALUE}`;
    },
  },
  {
    value: 'RENAME_USER',
    label: 'User Rename',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL, NEW_VALUE } = props;
      return `${USER_EMAIL} renamed to ${NEW_VALUE}`;
    },
  },
  {
    value: 'UNENROLL_USER_FROM_STRONG_AUTH',
    label: 'User Strong Auth Unenroll',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `User ${USER_EMAIL} unenrolled from Strong Auth`;
    },
  },
  {
    value: 'SUSPEND_USER',
    label: 'User Suspension',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} suspended`;
    },
  },
  {
    value: 'UNARCHIVE_USER',
    label: 'User Unarchival',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} unarchived`;
    },
  },
  {
    value: 'UNDELETE_USER',
    label: 'User Undeletion',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} undeleted`;
    },
  },
  {
    value: 'UNSUSPEND_USER',
    label: 'User Unsuspension',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} unsuspended`;
    },
  },
  {
    value: 'UPGRADE_USER_TO_GPLUS',
    label: 'User Upgrade To Google+',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `${USER_EMAIL} was upgraded to Google+`;
    },
  },
  {
    value: 'USERS_BULK_UPLOAD',
    label: 'Users Bulk Upload',
    messageFormat: (props: EventMessageProps) => {
      const { BULK_UPLOAD_TOTAL_USERS_NUMBER, BULK_UPLOAD_FAIL_USERS_NUMBER } =
        props;
      return `A total of ${BULK_UPLOAD_TOTAL_USERS_NUMBER} users selected for upload. ${BULK_UPLOAD_FAIL_USERS_NUMBER} out of ${BULK_UPLOAD_TOTAL_USERS_NUMBER} users failed to be uploaded.`;
    },
  },
  {
    value: 'USERS_BULK_UPLOAD_NOTIFICATION_SENT',
    label: 'Users Bulk Upload Notification',
    messageFormat: (props: EventMessageProps) => {
      const { USER_EMAIL } = props;
      return `Notification of bulk users upload sent to ${USER_EMAIL}`;
    },
  },

  // Manually Added
  {
    value: 'SECURITY_INVESTIGATION_QUERY',
    label: 'Audit and Investigation Query',
    messageFormat: (props: EventMessageProps) => {
      const { INVESTIGATION_DATA_SOURCE, INVESTIGATION_QUERY } = props;
      return `Performed query for ${INVESTIGATION_DATA_SOURCE} data: ${INVESTIGATION_QUERY}`;
    },
  },
  {
    value: 'ALERT_CENTER_VIEW',
    label: 'Alert Center Viewed',
    messageFormat: (props: EventMessageProps) => {
      const { ALERT_ID } = props;
      return `Alert center details of alert ${ALERT_ID}`;
    },
  },
  {
    value: 'SECURITY_CENTER_RULE_THRESHOLD_TRIGGER',
    label: 'Activity Rule Threshold Trigger',
    messageFormat: (props: EventMessageProps) => {
      const {
        SECURITY_CENTER_RULE_NAME,
        SECURITY_CENTER_RULE_TRIGGER_WINDOW,
        SECURITY_CENTER_RULE_CONDITION,
        SECURITY_CENTER_RULE_THRESHOLD,
        SECURITY_CENTER_RULE_TIME_FRAME,
        SECURITY_CENTER_RULE_ACTION,
      } = props;
      return `Rule ${SECURITY_CENTER_RULE_NAME} was triggered. Trigger Window: ${SECURITY_CENTER_RULE_TRIGGER_WINDOW}, Conditions: ${SECURITY_CENTER_RULE_CONDITION}, Threshold: ${SECURITY_CENTER_RULE_THRESHOLD}, Time Frame: ${SECURITY_CENTER_RULE_TIME_FRAME}, Action: ${SECURITY_CENTER_RULE_ACTION}`;
    },
  },
  {
    value: 'SECURITY_CHART_DRILLDOWN',
    label: 'Chart Drilldown',
    messageFormat: (props: EventMessageProps) => {
      const { CHART_NAME, START_DATE, END_DATE, CHART_FILTERS } = props;
      return `Admin viewed drill down of security chart ${CHART_NAME} for start date ${START_DATE} and end date ${END_DATE} with filters ${CHART_FILTERS}`;
    },
  },
  {
    value: 'SECURITY_INVESTIGATION_OBJECT_CREATE_DRAFT_INVESTIGATION',
    label: 'Create Investigation',
    messageFormat: (props: EventMessageProps) => {
      const { INVESTIGATION_OBJECT_IDENTIFIER } = props;
      return `A draft investigation was created ${INVESTIGATION_OBJECT_IDENTIFIER}`;
    },
  },
];
